//
// locale_sr-Latn.js
// automatically generated by generateLocalePacks.js
//
import messages from '../../app/javascript/mastodon/locales/sr-Latn.json';
import localeData from "react-intl/locale-data/sr.js";
import { setLocale } from '../../app/javascript/mastodon/locales';
setLocale({messages, localeData});
